import { AdSlotContainer } from '../../../entities/ad-slot-container';
import { Event } from '../event';

export class AdSlotContainerLifecycleEvent extends Event {
  constructor (private readonly adSlotContainer: AdSlotContainer) {
    super();
  }

  public getAdSlotContainer (): AdSlotContainer {
    return this.adSlotContainer;
  }
}
